var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45201 9.61619V0.961426M11.0582 6.01004L7.45201 9.61619L3.84586 6.01004M13.9431 9.61619V12.5011C13.9431 12.8837 13.7911 13.2506 13.5206 13.5211C13.2501 13.7916 12.8832 13.9436 12.5006 13.9436H2.4034C2.02083 13.9436 1.65394 13.7916 1.38342 13.5211C1.11291 13.2506 0.960938 12.8837 0.960938 12.5011V9.61619",
    stroke: "#2B3688",
    strokeWidth: 1.92328,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload12);
export default __webpack_public_path__ + "static/media/download12.1864e2a14463aee269282b1b9452d738.svg";
export { ForwardRef as ReactComponent };